import { forwardRef, type SVGProps } from 'react';

export const ArticleSuccessIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function ArticleSuccessIcon(props, ref) {
  return (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M19.9049 17.1632C20.2036 17 20.3996 16.6832 20.3996 16.3184V7.67844C20.3996 7.31364 20.2036 6.99684 19.9049 6.83364L12.5316 2.57124C12.3823 2.45604 12.1956 2.39844 11.9996 2.39844C11.8036 2.39844 11.6169 2.45604 11.4676 2.57124L4.09428 6.83364C3.79561 6.99684 3.59961 7.31364 3.59961 7.67844V16.3184C3.59914 16.4923 3.645 16.663 3.73221 16.8119C3.81942 16.9609 3.94465 17.0824 4.09428 17.1632L11.4676 21.4256C11.6169 21.5408 11.8036 21.5984 11.9996 21.5984C12.1956 21.5984 12.3823 21.5408 12.5316 21.4256L19.9049 17.1632ZM6.43695 7.67844L11.9996 4.46244L17.5623 7.67844L11.9996 10.8944L6.43695 7.67844ZM14.8999 16.9718C14.9452 16.9906 14.9938 17 15.0456 17C15.0974 17 15.146 16.9906 15.1913 16.9718C15.2367 16.9533 15.2788 16.9217 15.3176 16.877L18.8931 12.7606C18.9644 12.6786 19 12.5723 19 12.4416C19 12.3113 18.9644 12.2051 18.8931 12.123C18.8219 12.041 18.7296 12 18.6164 12C18.5029 12 18.4106 12.041 18.3393 12.123L15.0456 15.915L13.6562 14.3154C13.585 14.2334 13.4943 14.1924 13.3842 14.1924C13.2741 14.1924 13.1834 14.2334 13.1121 14.3154C13.0409 14.3975 13.0036 14.5037 13.0002 14.634C12.9971 14.7647 13.0312 14.871 13.1024 14.953L14.7736 16.877C14.8124 16.9217 14.8545 16.9533 14.8999 16.9718Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
});
